import { RadioButtonGroup } from "./RadioButtonGroup.jsx";

export function SiteTypeInput({ name, siteTypes, formContext, ...rest }) {
  const { control, reset, setValue } = formContext;

  return (
    <RadioButtonGroup
      isRequired
      control={control}
      name={name}
      // size="sm"
      label="What kind of site are you searching for?"
      options={siteTypes}
      onChange={(v) => {
        setValue(name, v, { shouldValidate: false, shouldDirty: true });
        setValue("selectedFilters", [], { shouldValidate: false });
        setValue("maxRVLength", "", { shouldValidate: false });
        setValue("maxElectric", "", { shouldValidate: false });
        setValue("doubleSitePreference", "any", { shouldValidate: false });
        setValue("accessibilityPreference", "exclude", {
          shouldValidate: false,
        });
      }}
      {...rest}
    />
  );
}
